











import { Component, Prop, Vue } from 'vue-property-decorator';
import TextInput from './_text.input.vue';
@Component({
  components: {
    'text-input': TextInput
  },
})
export default class InputName extends Vue {

  @Prop()
  placeholder!: string;

  public label = 'Nombres y Apellidos';
  public error = '';
  public icon = 'perm_identity'

  onChange($text) {
    console.error($text)
      if($text.length === 0){
          this.error = 'Nombre invalida';
      } else {
        this.$emit('nChange', $text)
          this.error = '';
      }
  }

}
